import { APP_ROUTES } from "../constants";

export interface RequesterScreeningConfig {
  requesterListReview?: boolean;
  actionRequired?: { type?: string } | null;
}

/**
 * Where a reopened request link starts. A confirmed list match is review.
 * A thin match with a saved draft returns to the form. Without a draft the
 * person composes again and the mint answers with the same form.
 */
export function requesterEntryRoute(
  config: RequesterScreeningConfig | null | undefined,
  options: { termsAccepted: boolean; hasDraft: boolean },
): string {
  if (config?.requesterListReview) return APP_ROUTES.REQUEST_REVIEW_PAGE;
  if (config?.actionRequired?.type === "OFAC_DISAMBIGUATION") {
    return options.hasDraft
      ? APP_ROUTES.REQUEST_SCREENING_PAGE
      : APP_ROUTES.TRANSFER_PAGE;
  }
  return options.termsAccepted
    ? APP_ROUTES.LANDING_PAGE
    : APP_ROUTES.WELCOME_PAGE;
}
